import { throwError } from 'rxjs';
import type { EventLogTypesService } from '../generated/event-log-types/event-log-types.service';
import type { CrudOps } from '../../../stores/generic.store';
import type { EventLogType } from '../../../types/event-log.interface';

// Catalogue is read-only on the server (swagger exposes only GET); write paths reject early
// to keep the contract honest while preserving the GenericState shape consumed by event-log.store.
const readOnlyReject = <T>(op: string) => throwError(() => new Error(`EventLogType is read-only: ${op} not supported`)) as T;

export const eventLogTypeCrud: CrudOps<EventLogType, EventLogTypesService> = {
  getAll: svc => svc.getEventLogTypeListResource<EventLogType[]>(),
  getById: (svc, id) => svc.getEventLogTypeDetailResource<EventLogType>({ id }),
  create: () => readOnlyReject('create'),
  update: () => readOnlyReject('update'),
  delete: () => readOnlyReject('delete'),
};
